import LanesAdmin from "../components/LanesAdmin";
import AdminPageHeader from "../components/admin-page-header";
import "../styles/admin-settings.css";

const AdminLanes = () => (
    <div className="page-data page-data-wide" style={{ height: "calc(100vh - 56px)", overflow: "auto" }}>
        <AdminPageHeader
            titleKey="lanes_settings"
            backTo="/admin/warehouse"
            hideSearch
            crumbs={[
                { labelKey: "admin_panel", to: "/admin" },
                { labelKey: "warehouse_menu_title", to: "/admin/warehouse" },
                { labelKey: "lanes_settings" },
            ]}
        />
        <div className="admin-settings-section">
            <LanesAdmin />
        </div>
    </div>
);

export default AdminLanes;
